import * as React from "react";
import * as axios from "axios";
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import {translate} from "react-i18next";
import moment from "moment";
import {getAPIUrl, parseUrlParams} from "../api/common";
import Stage, {ERROR_STATES, STAGES} from "./Stage";

import {Button, Col, Container} from "reactstrap";

import DebugMenu, {isDebugUser} from "./DebugMenu";
import {loadDS360Data, saveAppointmentDate, saveCustomerData, saveCustomerValidationData} from "../api/ds360";
import {getNextStage, isUserInCCStage} from "./nextStage";
import SmallDebugMenu from "./SmallDebugMenu";
import {getOrderStatus} from "../api/orderStatus";
import {BrowserView,MobileView, isMobile} from "react-device-detect";


/**
 * Debugging Switch to activate Console Logging for Stages
 * @type {boolean}
 */
const DEBUG = true;


/**
 * MainPage - zentrale
 */
class MainPage extends React.Component {


    /**
     * constructor
     * @param props
     */
    constructor(props) {

        super(props);

        // parse url parameters (e.g. urlIdent)
        const urlParams = parseUrlParams();
        // Debugging: console.log( "urlParams: " ); console.log( urlParams );

        // set this.state
        this.state = {
            stage: STAGES.LOADING,
            urlIdent: urlParams ? urlParams.urlIdent : null,
            benachrichtigungPer: urlParams ? ( urlParams.hasOwnProperty('E') ? "Email" : ( urlParams.hasOwnProperty('S') ? "SMS" : ( urlParams.hasOwnProperty('B') ? "Brief" : null ) ) ) : null,
            callbackRequestedSuccessfully: false,
            validationDone: false,
            callbackParam: false,
            apiAction: false,
            selectedDate: false,
            Response_Hinweis_Techniker: "",
			footerClass: 'fixed-to-bottom'
        };

        // Debugging:
        if( DEBUG ) console.log( "#########################################################################################");
        if( DEBUG ) console.log( "FNX: MainPage.js / construct / props");
        if( DEBUG ) console.log(props);
        // console.log( "FNX: MainPage:" );
        // console.log( "FNX: MainPage benachrichtigungPer: " + this.state.benachrichtigungPer );
        // console.log( "FNX: MainPage validationDone: " + this.state.validationDone );
        // console.log( "FNX: MainPage callbackRequestedSuccessfully: " + this.state.callbackRequestedSuccessfully );

        window.debugSetStage = (stage) => {
            this.setState({stage: stage});
        };

        window.toggleDebugMenu = () => {
            this.setState({showDebugMenu: !this.state.showDebugMenu})
        };
        window.showError = this.serverErrorCallback;

        this.stageStack = [];
    }


    /**
     * Common Submit Callback
     * handles form submits with radio button options
     */
    commonSubmitCallback = (selectedOption) => {

        if( DEBUG ) console.log( "#########################################################################################");
        if( DEBUG ) console.log( "FNX: MaingPage.js // commonSubmitCallback");
        if( DEBUG ) console.log( "FNX: MaingPage.js // commonSubmitCallback // selectedOption: " + selectedOption);
        this.state.selectedOption = selectedOption;
        // if( DEBUG ) console.log( this.state );
        // this.setStage(ERROR_STATES.CALLBACK_CONFIRM);

        // specific handling

            // line/service is working -> API POST
            if( this.state.selectedOption == "working" ) {
                if( DEBUG ) console.log( "FNX: MaingPage.js // commonSubmitCallback // line/service is working -> API POST");
                // TODO FH API POST - line/service is working
            }

            // TAM6003 Response_Hinweis_Techniker vorhalten
            if( parseInt( this.state.ds360APIResult.RESULT_CODE ) == 6003 && this.state.stage == STAGES.TAM6003_ENTRY_CALENDAR ) {
                this.state.Response_Hinweis_Techniker = selectedOption;
                if( DEBUG ) console.log( "FNX: MaingPage.js // commonSubmitCallback // this.state.Response_Hinweis_Techniker = " + this.state.Response_Hinweis_Techniker);
            }

            // general "back" mechanism - go back one stage in
            if( this.state.selectedOption == "goBackOneStage" ) {
                if( DEBUG ) console.log( "FNX: MaingPage.js // commonSubmitCallback // goBackOneStage via stageStack");
                if( DEBUG ) console.log( this.stageStack );
                // return to last REGULAR stage before the current stage by traversing through this.stageStack from reverse (!)
                for (let i = this.stageStack.length - 1; i >=0 ; i--) {
                    // console.log( this.stageStack[i]);
                    if(this.stageStack[i] === this.state.stage){
                        continue;
                    }
                    return this.setStage( this.stageStack[i] );
                }
                // this.setStage( this.stageStack[this.stageStack.length - 1] );
            }

        this.nextStage();

    };


    /**
     * Welcome-Stage Callback
     */
    welcomeSubmitCallback = (selectedOption) => {

        if( DEBUG ) console.log( "#########################################################################################");
        if( DEBUG ) console.log( "FNX: MaingPage.js // welcomeSubmitCallback");
        if( DEBUG ) console.log( "FNX: MaingPage.js // welcomeSubmitCallback // selectedOption: " + selectedOption);
        this.state.selectedOption = selectedOption;
        // if( DEBUG ) console.log( this.state );
        // this.setStage(ERROR_STATES.CALLBACK_CONFIRM);

        // line/service is working -> API POST
        if( this.state.selectedOption == "working" ) {
            if( DEBUG ) console.log( "FNX: MaingPage.js // welcomeSubmitCallback // line/service is working -> API POST");
            // TODO FH API POST - line/service is working
        }

        this.nextStage();

    };




    /**
     * user clicks on callback request button
     */
    contactVodafoneCallback = () => {
        // this.setState({stageBeforeCallback: });
        /*
        // console.log( "FNX: contactVodafoneCallback / this.stageStack:");
        // console.log(this.stageStack);
        // console.log("1 Schritte zurück: ");
        // console.log(this.stageStack[this.stageStack.length - 1]);
        // console.log("2 Schritte zurück: ");
        // console.log(this.stageStack[this.stageStack.length - 2]);
        // console.log("3 Schritte zurück: ");
        // console.log(this.stageStack[this.stageStack.length - 3]);
        */
        this.setStage(ERROR_STATES.CALLBACK);
    };


    /**
     * sets the current stage
     * @param stage
     */
    setStage = (stage) => {
        // only push to stageStack if current is different from previous
        if( DEBUG ) console.log( "FNX: MaingPage.js // setStage");
        if( DEBUG ) console.log( "FNX: MaingPage.js // this.state.stage = " + this.state.stage );
        if( DEBUG ) console.log( "FNX: MaingPage.js // this.stageStack = "); if( DEBUG ) console.log( this.stageStack );
        if( DEBUG ) console.log( "FNX: MaingPage.js // last stage before (this.stageStack[this.stageStack.length-1]) = " + this.stageStack[this.stageStack.length-1] );
        if( this.state.stage !== this.stageStack[this.stageStack.length-1] ) {
            this.stageStack.push(this.state.stage);
        }
        this.setState({stage: stage});
    };


    /**
     * determine next stage
     */
    nextStage = async() => {

        if( DEBUG ) console.log( "#########################################################################################");
        if( DEBUG ) console.log( "FNX: MaingPage.js // nextStage");
        if( DEBUG ) console.log( "FNX: MaingPage.js // nextStage // this.state: ");
        if( DEBUG ) console.log( this.state );

        this.stageStack.push(this.state.stage);

        const previousState = this.state;

        this.setStage(STAGES.LOADING);

        /* TODO ENTFERNEN
        this.orderStatus = await getOrderStatus(this.state.urlIdent)
            .catch((e) => {
                return this.serverErrorCallback(e);
            });
        if(!this.orderStatus){
            // return;
        }
        this.orderStatus = this.orderStatus.data;
        */
        this.orderStatus = false;

        this.setState(
            {
                stage: getNextStage(
                    this.state.ds360APIResult,
                    previousState,
                    this.orderStatus,
                    this.stageStack
                )
            }
        );

        // console.log( "FNX: "); console.log("previousState:");console.log(previousState); console.log("this.state:");console.log(this.state);

    };

    previousStage = () => {
        this.setState({stage: this.state.stage-1});
    };



    /**
     * calendar select callback
     * saves selected appointment date in app state and goes on to next stage
     * @param selectedDate
     * @returns {Promise<void>}
     */
    calendarSelectCallback = async(selectedDate) => {

        if( DEBUG ) console.log( "FNX: MainPage.js calendarSelectCallback / selectedDate: ");
        if( DEBUG ) console.log( selectedDate );

        // save selected date in app state
        this.setState({
            selectedDate: selectedDate,
        })

		// goto next stage (determined via checkCareStageHelper)
		this.nextStage();

    };


    /**
     * change appointment -> go to stage APPOINTMENT_SELECT_CALENDAR
     */
    changeAppointment = () => {
        this.setStage(STAGES.APPOINTMENT_SELECT_CALENDAR);
    };


    /**
     * Show ERROR_STATES.SERVER_ERROR when an error occured
     * @param error
     */
    serverErrorCallback = (error) => {
        this.setState({
            serverError: error,
            stage: ERROR_STATES.SERVER_ERROR
        });
    };


    /**
     * previous tenant select callback
     * @param state
     * @returns {Promise<void>}
     */
    previousTenantSelectCallback = async(state) => {
        const newState = this.state;
        newState.ds360APIResult.previousTenant = state;
        newState.stage = newState.stage+1;
        this.setState(newState);
    };


    /**
     * POST user data to API
     * @param formState
     */
    saveUserDataToCCApi = (formState) => {

        // merge this.state and formState into postData Array
        let postData = Object.assign({}, this.state, formState);

        if( DEBUG ) console.log( "#########################################################################################");
        if( DEBUG ) console.log( "FNX: MainPage.js // saveUserDataToCCApi // formState:" );
        if( DEBUG ) console.log( formState );
        if( DEBUG ) console.log( "FNX: MainPage.js // saveUserDataToCCApi // this.state:" );
        if( DEBUG ) console.log( this.state );
        if( DEBUG ) console.log( "FNX: MainPage.js // saveUserDataToCCApi // postData:" );
        if( DEBUG ) console.log( postData );

        // call saveCustomerData from "../api/ds360";
        saveCustomerData(this.state.urlIdent, postData)
            .then(() => {
                if( DEBUG ) console.log( "FNX: MainPage.js // saveUserDataToCCApi // saveCustomerData OK!" );
                // TODO: aktivieren und die API muss funktionieren
                // load updated data from CC API to verify customerStatus; the customerData will again be evaluated to determine next stage
                // return this.loadDS360Data();
            })
            .catch((e) => {
                if( DEBUG ) console.log( "FNX: MainPage.js // saveUserDataToCCApi // saveCustomerData ERROR:" );
                if( DEBUG ) console.log( e );
                this.serverErrorCallback(e);
            })
        // this.state.selectedDate = this.state.ds360APIResult.proposalDate;
        // this.saveAppointmentDate(postData);
    };


    /**
     * confirm appointment
     */
    confirmAppointment = () => {
        this.state.selectedDate = this.state.ds360APIResult.proposalDate;
        this.saveAppointmentDate(this.state);
    };


    /**
     * save appointment date
     * @param state
     */
    saveAppointmentDate = (state) => {

        //Save a copy of the state before we show the loading page
        //We need to do this to be able to correctly return the next stage
        this.setStage(STAGES.LOADING);

        // call saveAppointmentDate from "../api/ds360";
        saveAppointmentDate(this.state.urlIdent, state, this.state.selectedDate)
            .then(() => {

                // TODO: Hackerbay did send debugUsers directly to STAGES.WAITING_FOR_APPOINTMENT - why? deactivated this code block as it causes trouble with 1T99999xxx test users
                if( false  ) {
                    if(isDebugUser(this.state.urlIdent) === true){
                        if(isUserInCCStage(this.state.ds360APIResult)){
                            return this.setStage(STAGES.WAITING_FOR_APPOINTMENT);
                        }
                        return this.setStage(STAGES.CURRENT_STATUS);
                    }
                }

                return this.loadDS360Data();

            })
            .catch((e) => {
                this.serverErrorCallback(e);
            })
    };


    /**
     * load DS360 Data
     * @returns {Promise<void>}
     */
    loadDS360Data = async() => {

		if( DEBUG ) console.log( "#########################################################################################");
		if( DEBUG ) console.log( "FNX: MainPage.js // loadDS360Data // call loadDS360Data (await loadDS360Data)" );

        // set loading animation
        this.setStage(STAGES.LOADING);

        // query API via Cloudfunction to get Customer Data
        const response = await loadDS360Data(this.state.urlIdent)
			.catch((e) => {
				if( DEBUG ) console.log( "FNX: MainPage.js // loadDS360Data // call loadDS360Data (await loadDS360Data) = ERROR" );
				if( DEBUG ) console.log( e );
				if( DEBUG ) console.log( response );
				this.serverErrorCallback(e);
				return null;
            });

		if( DEBUG ) console.log( "FNX: MainPage.js // loadDS360Data // call loadDS360Data (await loadDS360Data) = OK" );
		if( DEBUG ) console.log( response );

        if(!response){
            return;
        }

        const ds360APIResult = response.data;

        // begin Debug Override
        const debugStageOverride = this.state.debugStateOverride;
        if(debugStageOverride){
            return this.setState({
                stage: debugStageOverride,
                ds360APIResult: ds360APIResult
            });
        }
        // end Debug Override

        // set this manually because the nextStage() function needs it
        this.state.ds360APIResult = ds360APIResult;

        // determine next stage
        this.nextStage();

    };



    /**
     * user clicks on top navigation link/button
	 * sets stage STAGES.FOOTER
     */
	openTopNav = () => {
        // console.log("openTopNav reached - STAGES.FOOTER");
	    this.setStage(STAGES.FOOTER);
    };

    /**
     * user clicks on top navigation link/button
     * sets stage STAGES.HOMESCREEN_BUTTON
     */
    openHomeScreen = () => {
        // console.log("openHomeScreen reached - STAGES.HOMESCREEN_BUTTON");
        this.setStage(STAGES.HOMESCREEN_BUTTON);
    };


    /**
     * On Click on Close Button Function (e.g. used in Callback Overlay)
     * @returns {*}
     */
    setupOnClickClose = () => {

        /*
            console.log( "FNX: setupOnClickClose / this.stageStack:");
            console.log(this.stageStack);
            console.log("1 Schritte zurück: ");
            console.log(this.stageStack[this.stageStack.length - 1]);
            console.log("2 Schritte zurück: ");
            console.log(this.stageStack[this.stageStack.length - 2]);
            console.log("3 Schritte zurück: ");
            console.log(this.stageStack[this.stageStack.length - 3]);
        */

        // Close of APPOINTMENT_SELECT_CALENDAR-Stage - return to last REGULAR stage (not FOOTER, not APPOINTMENT_SELECT_CALENDAR) by traversing through this.stageStack from reverse (!)
        if(this.state.stage === STAGES.APPOINTMENT_SELECT_CALENDAR){

                /*
                    console.log( "FNX: setupOnClickClose / STAGES.APPOINTMENT_SELECT_CALENDAR")
                    console.log( "FNX: setupOnClickClose / this.stageStack:");
                    console.log(this.stageStack);
                    console.log( "FNX: get last REGULAR stage (not FOOTER, not APPOINTMENT_SELECT_CALENDAR" );
                */

                // return to last REGULAR stage (not FOOTER, not APPOINTMENT_SELECT_CALENDAR) by traversing through this.stageStack from reverse (!)
                for (let i = this.stageStack.length - 1; i >=0 ; i--) {
                    // console.log( this.stageStack[i]);
                    if(this.stageStack[i] === STAGES.APPOINTMENT_SELECT_CALENDAR || this.stageStack[i] === STAGES.FOOTER){
                        continue;
                    }
                    return this.setStage( this.stageStack[i] );
                }

        }

        // Close of Footer-Stage - go back 1 step
        if(this.state.stage === STAGES.FOOTER){
            // goto back to stage BEFORE footer stage = this.stageStack.length - 1
                /*
                // console.log( "FNX: setupOnClickClose / STAGES.FOOTER")
                // console.log( "FNX: setupOnClickClose / this.stageStack:");
                // console.log(this.stageStack);
                // console.log("Go back 1 Stage in Stack: ");
                // console.log(this.stageStack[this.stageStack.length - 1]);
                */
            return this.setStage( this.stageStack[this.stageStack.length - 1] );
        }

        // Close of HOMESCREEN_BOTTON-Stage - go back 1 step
        if(this.state.stage === STAGES.HOMESCREEN_BUTTON){
            // goto back to stage BEFORE footer stage = this.stageStack.length - 1
            /*
             // console.log( "FNX: setupOnClickClose / STAGES.FOOTER")
             // console.log( "FNX: setupOnClickClose / this.stageStack:");
             // console.log(this.stageStack);
             // console.log("Go back 1 Stage in Stack: ");
             // console.log(this.stageStack[this.stageStack.length - 1]);
             */
            return this.setStage( STAGES.CURRENT_STATUS );
        }

        // Close of Callback-Stage  - go back 1 step
        if(this.state.stage === ERROR_STATES.CALLBACK){
            // goto back to stage BEFORE callback stage = this.stageStack.length - 1
                /*
                // console.log( "FNX: setupOnClickClose / ERROR_STATES.CALLBACK")
                // console.log( "FNX: setupOnClickClose / this.stageStack:");
                // console.log(this.stageStack);
                // console.log("Go back 1 Stage in Stack: ");
                // console.log(this.stageStack[this.stageStack.length - 1]);
                */
            return this.setStage( this.stageStack[this.stageStack.length - 1] );
            // code was before:
            // return this.setStage(STAGES.SUCCESS);
        }

        // Close of Callback-CONFIRM-Stage  - go back 2 steps (the stage before the callback stage)
        if(this.state.stage === ERROR_STATES.CALLBACK_CONFIRM){
            this.callbackSubmitted = true;
            this.setState({callbackSubmitted: true});
            // goto back to stage BEFORE CALLBACK stage = this.stageStack.length - 2 (2 steps back)
                /*
                // console.log( "FNX: setupOnClickClose / ERROR_STATES.CALLBACK_CONFIRM")
                // console.log( "FNX: setupOnClickClose / this.stageStack:");
                // console.log(this.stageStack);
                // console.log("Go back 2 Stages in Stack: ");
                // console.log(this.stageStack[this.stageStack.length - 2]);
                */
            return this.setStage( this.stageStack[this.stageStack.length - 2] );
        }

        // User is in CC stage, go to next stage
        if(isUserInCCStage(this.state.ds360APIResult)){
            return this.nextStage();
        }

        // User is in appointment setup stage, return them to the intro screen
        if(isMobile){
            return this.setStage(STAGES.APPOINTMENT_SELECT);
        }

        // default: return to welcome stage
        return this.setStage(STAGES.WELCOME);

    };

    /**
     * callback function triggered when customer callback request has been sent successfully
     */
    callbackRequestCallback = () => {
        if( DEBUG ) console.log("FNX: MainPage.js // callbackRequestCallback"); if( DEBUG ) console.log(this.stage);
        this.setState({callbackRequestedSuccessfully: true});
        // this.setStage(ERROR_STATES.CALLBACK_CONFIRM);
        this.nextStage();
    };


    /**
     * validationCallback
     * @param bValidation
     * @returns void
     */
    validationCallback  = async(bValidation) => {
        // console.log( "FNX: validationCallback / bValidation: __" + bValidation + "__" ); console.log(this.stage);
        // this.setState({callbackRequestedSuccessfully: true});
        // console.log( this.state.ds360APIResult );

        // validation successful (VALID) -> goto Welcome Stage
        if( bValidation ) {

            // set loading animation
            this.setStage(STAGES.LOADING);

            const response = await saveCustomerValidationData( this.state.urlIdent, bValidation )
                .catch((e) => {
                    this.serverErrorCallback(e);
                    return null;
                });

            if(!response){
                return;
            }

            const ds360APIResult = response.data;

            // set validation execution bool this.state.validationDone to true
            // console.log( "FNX: validationCallback / VALID / saveCustomerValidationData / ds360APIResult // START "); console.log( ds360APIResult ); console.log( "//END" );
            this.state.validationDone = true;

            // set customerStatus to 'unselected' to avoid reloading data from API - could be quirky?!
            // console.log( "FNX: validationCallback / VALID / set customerStatus to 'unselected' to avoid reloading data from API");
            this.state.ds360APIResult.customerStatus = "unselected";

            // load data from api to get current snapshot of customer's data! - obsolete solution because of problems with this.loadDS360Data() forcing the user to the next stage!
            // console.log("FNX: validationCallback / VALID / set customerStatus to z / load updated customer's data from API via loadDS360Data: ");
            // this.loadDS360Data();

            // goto welcome stage
            this.setStage(STAGES.WELCOME);

        // validation not successful (INVALID) -> goto Invalid Stage
        } else {

            // set loading animation
            this.setStage(STAGES.LOADING);

            const response = await saveCustomerValidationData( this.state.urlIdent, bValidation )
                .catch((e) => {
                    this.serverErrorCallback(e);
                    return null;
                });

            if(!response){
                return;
            }

            const ds360APIResult = response.data;

            // console.log( "FNX: validationCallback / VALID / saveCustomerValidationData / ds360APIResult: ");
            // console.log( ds360APIResult );
            this.state.validationDone = true;
            this.setStage(STAGES.INVALID);
        }
        // this.setStage(ERROR_STATES.CALLBACK_CONFIRM);
        // this.nextStage();
        /*
        this.setState({
            selectedDate: selectedDate,
            stage: this.state.stage+1
        })
        */
    };


    /**
     * componentDidMount - load data from ds360 API
     */
    componentDidMount() {
       	if( DEBUG ) console.log( "FNX: MainPage.js // componentDidMount // loadDS360Data" );
        this.loadDS360Data()
    }

    /**
     * componentDidUpdate - load data from ds360 API if urlIdent or other important customer parameters/data changed
     * @param prevProps
     * @param prevState
     * @param snapshot
     * @returns {Promise<void>}
     */
    componentDidUpdate(prevProps, prevState, snapshot) {

        // console.log( "FNX: componentDidUpdate / prevProps / prevState / snapshot //START" ); console.log(prevProps); console.log(prevState); console.log(snapshot); console.log( "//END" );
        // console.log( "FNX: componentDidUpdate / Current Props / Current State /START" ); console.log(this.pros); console.log(this.state); console.log( "//END" );

        // check if urlIdent changed -> then reload data from APIs ("If the urlIdent changed for debugging, reload everything")
        if(prevState.urlIdent !== this.state.urlIdent){
	       	if( DEBUG ) console.log( "FNX: MainPage.js // componentDidUpdate // urlIdent changed -> reload data from APIs (loadDS360Data)" );
            return this.loadDS360Data()
        }

    }

	/**
     * render function
     * called every time a new stage is rendered
	 * @returns {*}
	 */
	render() {

        if( DEBUG ) console.log( "FNX: MainPage.js / render" );

		// no urlIdent? show debug menu or error
		if(!this.state.urlIdent){

            // show debug menu if configured in .env-file
            const showDebugMenu = (process.env.REACT_APP_SHOW_DEBUG_MENU === 'true');
            if(showDebugMenu){
                return <Container>
                    <DebugMenu
                        updateState={(values) => {console.log("Update Debug State", values); this.setState(values)}}
                        serverErrorCallback={this.serverErrorCallback}
                    />
                </Container>
            }

            if(this.state.stage !== ERROR_STATES.SERVER_ERROR){
                this.setStage(ERROR_STATES.SERVER_ERROR);
            }

        }

        // Debugging
        if( DEBUG ) {
            console.log( "FNX: MainPage render:" );
            console.log( "FNX: MainPage stage: " + this.state.stage );
            console.log( "FNX: MainPage nextStage: " + this.nextStage );
            console.log( "FNX: MainPage this.state.ds360APIResult: " + this.state.ds360APIResult );
            console.log( this.state.ds360APIResult );
            console.log( "FNX: -----" );
        }

        return <div className={"background-image"} style={{backgroundColor:"#f8f8fa", height:"100vh"}}>
            <Stage
                urlIdent={this.state.urlIdent}
                apiAction={this.state.apiAction}

                stage={this.state.stage}
                nextStage={this.nextStage}
                previousStage={this.previousStage}

                commonSubmitCallback={this.commonSubmitCallback}

                ds360APIResult={this.state.ds360APIResult}

                selectedDate={this.state.selectedDate}
                benachrichtigungPer={this.state.benachrichtigungPer}
                Response_Hinweis_Techniker={this.state.Response_Hinweis_Techniker}
                validationDone={this.state.validationDone}
                callbackRequestedSuccessfully={this.state.callbackRequestedSuccessfully}

                openTopNav={this.openTopNav}
                openHomeScreen={this.openHomeScreen}

                calendarSelectCallback={this.calendarSelectCallback}
                previousTenantSelectCallback={this.previousTenantSelectCallback}
                saveCustomerDataCallback={this.saveAppointmentDate}
                contactVodafoneCallback={this.contactVodafoneCallback}
                showMeinVodafoneLogin={this.showMeinVodafoneLogin}
                serverErrorCallback={this.serverErrorCallback}
                changeAppointment={this.changeAppointment}
                serverError={this.state.serverError}
                orderStatus={this.orderStatus}
                callbackRequestCallback={this.callbackRequestCallback}
                validationCallback={this.validationCallback}
                callbackSubmitted={this.state.callbackSubmitted}

                confirmAppointment={this.confirmAppointment}
                saveUserDataToCCApi={this.saveUserDataToCCApi}

                setupOnClickClose={this.setupOnClickClose}
            />
            <footer className={this.state.footerClass}>
                <div class="container">
                    <div class="row">
                        <Col>
                            <ul>
                                <li class="copyright">&copy; 2020 Vodafone GmbH</li>
								<li>|</li>
                                <li><a href="https://www.vodafone.de/impressum.html" target="_blank">Impressum</a></li>
                                <li>|</li>
								<li><a href="https://www.vodafone.de/unternehmen/datenschutz-privatsphaere.html" target="_blank">Datenschutz</a></li>
                            </ul>
                        </Col>
                    </div>
                </div>
            </footer>
        </div>;
    }
}

export default translate("translations")(MainPage);